import { inviteExternalContact } from 'flow/actions/contact-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import InviteColleagues from 'flow/route-components/InviteCollegues';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import React, { useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';

const InviteColleagueModal = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const [phoneNumber, setPhoneNumber] = useState('');

    const handleInviteExternalContact = () => {
        const parsedNumber = parsePhoneNumberFromString(phoneNumber);

        dispatch(
            inviteExternalContact({
                number: {
                    number: parsedNumber?.isValid() ? phoneNumber : null,
                    countryCode: parsedNumber?.isValid()
                        ? parsedNumber.country
                        : '',
                },
            }),
        );
        setPhoneNumber('');
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('Colleagues.Invite.External.Title')}
            onSubmit={handleInviteExternalContact}
            confirmButtonText={i18next.t('General.Invite')}
        >
            <InviteColleagues setNumber={setPhoneNumber} />
        </BaseModal>
    );
};

export default InviteColleagueModal;
